<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()"><ion-icon name="arrow-back-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Create Project</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item>
    <ion-input
      [(ngModel)]="name"
      (ionChange)="changeName()"
      inputmode="text"
      required
      label="Name"
      labelPlacement="floating"
      placeholder=""
      color="primary"
      autocomplete="off"
    ></ion-input>
  </ion-item>
  <ion-item>
    <ionic-selectable
      item-content
      [(ngModel)]="timezone"
      itemValueField="name"
      itemTextField="label"
      [items]="timezones"
      [canSearch]="true"
      (onChange)="timezoneChange($event)"
      closeButtonSlot="end"
      [hasInfiniteScroll]="true"
      (onSearch)="searchTimezone($event)"
      (onInfiniteScroll)="getMoreTimezones($event)"
      (onOpen)="onOpen()"
     >
    </ionic-selectable>
  </ion-item>
  <ion-item *ngIf="admin">
    <app-owner-select></app-owner-select>
  </ion-item>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button
          expand="full"
          (click)="create()"
          [disabled]="!name"
        >
          create
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
